<template>
  <el-form-item ref="formItem" verify class="sky-server-config">
    <div>{{ value }}</div>
  </el-form-item>
</template>
<script type="text/babel">
export default {
  name: 'SkyFormValue',
  components: {},
  props: {
    value: {
      type: Object
    },
    data: {
      type: Object
    },
    defaultValue: {
      type: Object
    }
  },
  created() {},
  data() {
    return {
      hasDefault: false
    }
  },
  watch: {
    defaultValue(value) {
      if (!this.value) {
        this.value = value
      }
    },
    value(value) {
      this.value = value
      this.$emit('input', this.value)
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(delivery-deploy-product) {
}
</style>
